import { withInstall } from '@bigin/utils'

import Divider from './src/divider.vue'

export const BDivider = withInstall(Divider)
export default BDivider

export * from './src/divider'
